const PubNub = require('pubnub')

export default {
  install (Vue, options) {
    // Initialize the PubNub instance

    const pubnub = new PubNub({
      subscribeKey: options.subscribeKey,
      publishKey: options.publishKey,
      userId: 'lamusica-moderator',
      // logLevel: PubNub.LogLevel.Debug,
      ssl: true
    })

    Vue.prototype.$pubnub = pubnub
  }
}
